export default ({
  namespaced: true,
  state: {
    view: 'dialogWarning',
    // btnClose para mostrar o botão de sair
    values: {text: '', showDialog: false, btnClose: false}
  },
  getters: {
    values: state => {
      return state.values
    }
  },
  mutations: {
    change_values (state, payload) {
      // caso não tenha sido passado o btnClose, passa ele como false
      Object.assign(state.values, {btnClose: false}, payload)
    }
  }
})



// WEBPACK FOOTER //
// ./src/store/dialogWarning.js